module.exports = __webpack_public_path__ + "img/wei.b67903ab.png";